export default {"src":"/_next/static/media/search.950b7fc6.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};